let FormFeedback = function (props) {
  if (props.errors.length) {
    return (
      <div className="mc-form-feedback">
        {tx("oops") + " " + props.errors.join(" ")}
      </div>
    );
  }

  return null;
};

module.exports = FormFeedback;